export default __webpack_public_path__ + "static/media/notice_icon.c1762107.svg";